window.setCookie = function(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

window.getCookie = function(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

window.deleteCookie = function(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}



console.log('Backend Script');

window.addEventListener('DOMContentLoaded', function(event){
    
    let deliveryRadio = document.getElementsByClassName('js-delivery-selection');
    let deliveryTabs = document.getElementsByClassName('delivery-selection-fields__item');
    
    Array.from(deliveryRadio).forEach(radio => radio.addEventListener('change', function () {
        let currentIndex = Array.from(deliveryRadio).indexOf(this);


        [].forEach.call(deliveryTabs, function(el) {
            el.style.display = 'none';
        });

        deliveryTabs[currentIndex].style.display = 'block';

        setTimeout(function () {
            window.stickySidebar.updateSticky();
        }, 50);

    }));


    setTimeout(function () {
        document.body.classList.add('doc-ready');
    }, 200);

    window.addEventListener('load', function (ev) {
        document.body.classList.add('doc-ready');
    });


    let catalogLoadBtn = document.getElementsByClassName('js-load-more')[0];

    if(catalogLoadBtn) {
        catalogLoadBtn.addEventListener('click', function (e) {

            catalogLoadBtn.classList.add('is-loading');
            setTimeout(function () {
                $.ajax({
                    url: "catalog-ajax.html"
                }).done(function (data) {
                    $('.catalog-grid').append(data);
                    setTimeout(function () {
                        $('.catalog-grid__item.is-loading').removeClass('is-loading');
                        catalogLoadBtn.classList.remove('is-loading');
                        window.frontEndFuncs.itemTileSldier();
                        window.frontEndFuncs.lazyLoad();
                    }, 100)
                });

            }, 3000);

            e.preventDefault();
        })

    }


    $('.catalog-filter select, .catalog-filter input, .catalog-sort select').on('change', function(){
        $('.catalog-grid').addClass('is-loading');
        document.body.classList.add('mobile-buttons-show');

        // тут какой то ajax запрос
        setTimeout(function () {
            $('.catalog-grid').removeClass('is-loading');

            window.frontEndFuncs.lazyLoad();
        }, 3000);

    });


    let favoriteBtn = document.querySelectorAll('.cart-btn, .js-cart-add');

    Array.from(favoriteBtn).forEach(button => button.addEventListener('click', function(e){

        let currentBtn = this;
        currentBtn.classList.add('is-loading');

        setTimeout(function () {
            document.body.classList.add('show-cart');
            currentBtn.classList.toggle('is-active');
            currentBtn.classList.remove('is-loading');
        }, 1000);


        setTimeout(function () {
            document.body.classList.remove('show-cart');
        }, 4000);
        e.preventDefault();
    }));


    $('body').on('click', '.cart-item-small__remove', function () {
        let item = $(this).closest('.cart-item-small');
        item.addClass('is-remove');
        item.slideUp(300);
        setTimeout(function () {
            item.remove();
            if($('.cart-item-small').length === 0 ){
                $.fancybox.close();
                $('.header-cart').addClass('empty');
                setTimeout(function () {
                    $('.header-cart-drop').remove();
                }, 800);
            }
        }, 300)
    });


    if(window.getCookie('cityConfirmed') != '1'){
        setTimeout(function () {
            document.body.classList.add('show-city-alert');
        }, 3000);
    }

    let closeCityBtn  = document.getElementsByClassName('js-close-city');

    Array.from(closeCityBtn).forEach(button => button.addEventListener('click', function(e){
        document.body.classList.remove('show-city-alert');
        window.setCookie('cityConfirmed', '1', 7);
        e.preventDefault();
    }));


    let tasteRadio = document.getElementsByClassName('js-taste-radio');
    let tasteRadioResult = document.getElementsByClassName('js-selected-taste')[0];

    Array.from(tasteRadio).forEach(button => button.addEventListener('change', function(e){
        tasteRadioResult.innerHTML = document.querySelector('.js-taste-radio:checked').value;
        e.preventDefault();
    }));


    let bookRadio = document.getElementsByClassName('book-radio__input');
    let bookRadioResult = document.getElementsByClassName('js-selected-book')[0];

    Array.from(bookRadio).forEach(button => button.addEventListener('change', function(e){
        bookRadioResult.innerHTML = document.querySelector('.book-radio__input:checked').value;
        e.preventDefault();
    }));


    if(window.getCookie('cookieConfirmed') != '1'){
        setTimeout(function () {
            document.body.classList.add('show-cookie-alert');
        }, 3000);
    }

    let closeCookieBtn  = document.getElementsByClassName('js-close-cookie-alert');

    if(closeCookieBtn.length > 0){
        closeCookieBtn[0].addEventListener('click', function(){
            document.body.classList.remove('show-cookie-alert');
            window.setCookie('cookieConfirmed', '1', 7);
        })
    }

    $('.subscribe-promo__form').on('submit', function (e) {
        if($(this).valid()){
            $('.subscribe-promo__success').addClass('is-opened');
            e.preventDefault();
        }
    });


    $('.js-show-friend-form').on('click', function () {
        $('.friend-form').addClass('is-active');
    });


    $('.js-edit-order-profile').on('click', function (e) {
        $('.order-authorized-info').toggle();
        $('.profile--selected').toggle();
        e.preventDefault();
    })

});
